import { SwitchButton } from "components/switchButton";
import { IPickupAccountItem, PickupAccountType } from "interfaces";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import { TooltipParagraph } from "components/tooltipParagraph";
import moment from "moment";
import { isHaveActionPermission } from "utills/helpers";

interface PickupAccountTableProps {
  data?: IPickupAccountItem[];
  accountType: PickupAccountType;
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, accountType: PickupAccountType, isActive: boolean) => void;
}

export const PickupAccountTable = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  accountType,
  _toggleActive,
}: PickupAccountTableProps) => {
  return (
    <div className="flow-root">
      <div className="relative inline-block w-full align-middle box-border">
        <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
          <thead>
            <tr>
              <th scope="col" className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8">
                No
              </th>
              <th scope="col" className="th">
                User Name
              </th>
              {accountType === PickupAccountType.POS ? (
                <th scope="col" className="th">
                  Account name
                </th>
              ) : <></>}
              <th scope="col" className="th">
                Event name
              </th>
              <th scope="col" className="th">
                Role name
              </th>
              {accountType === PickupAccountType.POS ? (
                <th scope="col" className="th">
                  Pickup Type
                </th>
              ) : <></>}
              <th scope="col" className="th">
                Created at/by
              </th>
              <th scope="col" className="th">
                Status
              </th>
              <th scope="col" className="th w-28">
                <span className="sr-only">Action</span>
                <p className="">Action</p>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {data.map((item: IPickupAccountItem, index: number) => (
              <tr key={index}>
                <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                  {(currentPage - 1) * pageSize + 1 + index}
                </td>
                <td className="td overflow-x-auto">
                  {item.username}
                </td>
                {accountType === PickupAccountType.POS ? (
                  <td className="td overflow-x-auto">
                    {item.name}
                  </td>
                ) : <></>}
                <td className="td overflow-x-auto max-w-40">
                  <TooltipParagraph 
                    text={item.event_name}
                    className="whitespace-pre-wrap max-w-[280px]"
                  />
                </td>
                <td className="td overflow-x-auto">
                  {item.role_name}
                </td>
                {accountType === PickupAccountType.POS ? (
                  <td className="td overflow-x-auto capitalize">
                    {item.pickup_type}
                  </td>
                ) : <></>}
                <td className="td overflow-x-auto">
                  <p>{item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}</p>
                  <p>{item.created_by}</p>
                </td>
                <td className="td overflow-x-auto">
                  <SwitchButton
                    checked={item.is_active}
                    disabled={!isHaveActionPermission("accounts", "pickup", "edit")}
                    onChange={() => _toggleActive(item.id, item.role_name, item.is_active)}
                  />
                </td>
                <td className="td py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                  <div className="flex justify-start items-end gap-x-2 ">
                    <Link to={`/pickup/accounts/${item.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("accounts", "pickup", "edit") ? (
                      <Link
                        to={`/pickup/accounts/${item.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
